import './StaticTextInput.css';

import {
  StaticTextControl,
  StaticTextInputValue,
} from '../../../../../types/types';
import StaticTextBody from './components/StaticTextBody/StaticTextBody';
import { resolveDecorator } from '../../utils/resolveDecorator';

interface StaticTextInputProps {
  value: StaticTextInputValue;
  control: StaticTextControl;
}

const STATIC_TEXT_DECORATOR_CLASSNAME = 'static-text-decorator';

const StaticTextInput = ({ value, control }: StaticTextInputProps) => {
  const rows = control.height || 5;
  const rendering = control.rendering || 'plain';
  const resolvedDecorator = resolveDecorator(control.decorator);

  return (
    <div className="static-text-container">
      <StaticTextBody value={value} rendering={rendering} rows={rows} />
      {resolvedDecorator && (
        <div className={STATIC_TEXT_DECORATOR_CLASSNAME}>
          {resolvedDecorator}
        </div>
      )}
    </div>
  );
};

export default StaticTextInput;
